export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "Describe the case or ask a question",
      sybmolCount: "The number of characters should be from {min} to {max}",
      wordsCount: "The number of words should be from {min} to {max}",
      mobiledocPlaceholder: "Tell us more about the patient's examination data",
      mobiledocLabel: "Examination data",
      tags: "Tags",
      editCase: "Edit the case",
      anamnesisPlaceholder: "Tell us more about the patient's anamnesis",
      treatmentPlaceholder: "Tell us more about the patient's treatment",
      caseNotesPlaceholder: "Tell us more about the case",
      questionNotesPlaceholder: "Tell us more about the question",
      addImage: "Attach an image",
      anamnesis: "Anamnesis",
      treatment: "Treatment",
      notes: "Addition",
    },
    uploader: {
      case: {
        title: "Add a case",
        description: "Share interesting cases from your practice",
      },
      question: {
        title: "Ask a question",
        description: 'Users will respond faster if you select "Question".',
      },
    },
    title: "Community",
    description: "Knowledge sharing between doctors on clinical cases",
    all_cases: "All Cases",
    my_cases: "My Cases",
    case: {
      shareLink: {
        1: "Check out the case",
        2: "on " + process.env.VUE_APP_INSTALL_NAME + " Platform:",
      },
    },
    noCasesLang: {
      1: "There are no published cases in this language yet",
      2: "Be the first to share a DICOM study and get colleagues' opinions!",
    },
    filter: {
      status: {
        placeholder: "Sort cases",
        values: {
          popular: "Popular first",
          actual: "Recent first",
        },
        options: {
          base: "Show first",
          popular: "Popular",
          actual: "Recent",
        },
      },
      modality: {
        placeholder: "Modality",
      },
      bodypart: {
        placeholder: "Study area",
      },
      sex: {
        placeholder: "Sex",
        values: {
          M: "Male",
          F: "Female",
        },
      },
    },
  },
  h1_community: "Doctors Community",
};
